import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 * @param tenantId
 * @param plId
 */
class PriceListServices {
  /**
   *
   * @param {*} payload
   * @return
   */
  createPriceList = async (payload) => {
    const pl = await Helpers.post({
      url: Constants.PRICE_LIST,
      data: payload,
    });
    return pl;
  }

  /**
   *
   * @param {*} payload
   * @return
   */
   updatePriceList = async (payload) => {
     const pl = await Helpers.put({
       url: Constants.PRICE_LIST,
       data: payload,
     });
     return pl;
   }

   /**
    *
    * @param {*} payload
    * @return
    */
   updatePriceListStatus = async (payload) => {
     const pl = await Helpers.put({
       url: `${Constants.PRICE_LIST}/status`,
       data: payload,
     });
     return pl;
   }

    /**
     *
     * @param {*} payload
     * @return
     */
    deletePriceList = async (payload) => {
      const pl = await Helpers.delete({
        url: Constants.PRICE_LIST,
        data: payload,
      });
      return pl;
    }

    /**
     * @param {*} page
     * @param tenantId
     * @param priceListId
     * @param status
     * @param searchKeyword
     * @param {*} limit
     * @return
     */
  getPriceLists = async (tenantId, priceListId, isListScreen, customerId, states, page, limit, status, searchKeyword) => {
    let url = `${Constants.PRICE_LIST}?`;
    if (tenantId) url += `tenant_ids=${tenantId}&`;
    if (priceListId) url += `price_list_id=${priceListId}&`;
    if (isListScreen) url += `is_list_screen=${isListScreen}&`;
    if (customerId) url += `customer_id=${customerId}&`;
    // if (states) url += `applicable_state=${states}&`;
    if (limit) url += `limit=${limit}&`;
    if (page) url += `page=${page}&`;
    if (status) url += `is_active=${status}&`;
    if (searchKeyword) url += `search_keyword=${searchKeyword}&`;

    const pl = await Helpers.get({ url });
    return pl;
  }

  /**
     * @param {*} page
     * @param tenantId
     * @param priceListId
     * @param status
     * @param searchKeyword
     * @param {*} limit
     * @return
     */
       getApplyPriceLists = async (tenantId, priceListId, customerId, states, skuId) => {
         let url = `${Constants.PRICE_LIST}/prices?`;
         if (tenantId) url += `tenant_id=${tenantId}&`;
         if (priceListId) url += `price_list_id=${priceListId}&`;
         if (customerId) url += `customer_id=${customerId}&`;
         if (states) url += `applicable_state=${states}&`;
         if (skuId) url += `sku_ids=${skuId}&`;

         const pl = await Helpers.get({ url });
         return pl;
       }

       /**
     * @param {*} tenantId
     * @param pricingScheme
     * @return
     */
       getCustomPriceList = async (orgId, pricingScheme) => {
         const getCustomPriceList = await Helpers.getFile({
           url: `${`${Constants.PRICE_LIST}/download?org_id=${orgId}`}${pricingScheme ? `&pricing_scheme=${pricingScheme}` : ''}`,
         });
         return getCustomPriceList;
       }

       /**
     * @param {*} tenantId
     * @param pricingScheme
     * @return
     */
       getExistingPriceList = async (orgId, priceListId, includeOtherProducts) => {
         const getExistingPriceList = await Helpers.getFile({
           url: `${`${Constants.PRICE_LIST}/download_id?org_id=${orgId}`}${priceListId ? `&price_list_id=${priceListId}&include_other_products=${includeOtherProducts}` : ''}`,
         });
         return getExistingPriceList;
       }
}
export default new PriceListServices();
